import { find } from 'lodash'
import options from '../../areacode'

export default function (value, data, parentData) {
  const { areaCode = '86' } = parentData
  const option = find(options, { value: areaCode })

  if (option) {
    if (option.pattern.test(value)) {
      return {
        validate: true
      }
    } else {
      return {
        validate: false,
        message: '手机号码格式不正确，请重新输入'
      }
    }
  }

  return {
    validate: true
  }
}
